<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>工业和信息化部政府采购管理办法</h1>
        <div class="first">
          <p>工业和信息化部政府采购管理办法</p>
          <P>第一章 总 则</P>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <p>第一条 为改进和加强政府采购管理工作，依据《中华人民共和国政府采购法》、《中华人民共和国政府采购法实施条例》等法律法规，制定本方法。</p>
          <p>第二条 本方法适用于工业和信息化部本级及部属单位的政府采购活动。</p>

          <p>第三条 本方法所称政府采购，是指各单位按照政府采购法律、行政法规和制度规定的方式和程序，使用财政性资金采购国务院公布的集中采购目录内或采购限额标准以上的货物、工程和服务的行为。</p>

          <p>财政性资金是指纳入预算管理的资金，包括一般公共预算、政府性基金预算和其他资金。凡使用纳入部门预算管理的资金，不论来源，都应当纳入政府采购管理范围。</p>

          <p>第四条 政府采购应当有助于实现包括节约资源、保护环境、扶持不发达地区和少数民族地区、促进中小企业发展等国家经济和社会发展政策目标。</p>

          <p>第四条 国务院特种设备安全监督管理部门负责全国特种设备的安全监察工作，县以上地方负责特种设备安全监督管理的部门对本行政区域内特种设备实施安全监察（以下统称特种设备安全监督管理部门）。</p>

          <p>政府采购应当采购本国货物、工程和服务，但法律、行政法规等另有规定的除外。</p>
          <p>特种设备生产、使用单位的主要负责人应当对本单位特种设备的安全和节能全面负责。</p>

          <p>特种设备生产、使用单位和特种设备检验检测机构，应当接受特种设备安全监督管理部门依法进行的特种设备安全监察。</p>

          <p>第六条 特种设备检验检测机构，应当依照本条例规定，进行检验检测工作，对其检验检测结果、鉴定结论承担法律责任。</p>

          <p>第七条 县级以上地方人民政府应当督促、支持特种设备安全监督管理部门依法履行安全监察职责，对特种设备安全监察中存在的重大问题及时予以协调、解决。</p>

          <p>第八条 国家鼓励推行科学的管理方法，采用先进技术，提高特种设备安全性能和管理水平，增强特种设备生产、使用单位防范事故的能力，对取得显著成绩的单位和个人，给予奖励。</p>

          <p>国家鼓励特种设备节能技术的研究、开发、示范和推广，促进特种设备节能技术创新和应用。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>